import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Import Uganda images
import uganda1 from '../images/uganda1.jpeg';
import uganda2 from '../images/uganda2.jpeg';
import uganda3 from '../images/uganda3.jpeg';
import uganda4 from '../images/uganda4.jpeg';
import uganda5 from '../images/uganda5.jpeg';
import uganda6 from '../images/uganda6.jpeg';
import uganda7 from '../images/uganda7.jpeg';
import uganda8 from '../images/uganda8.jpeg';
import uganda9 from '../images/uganda9.jpeg';
import uganda10 from '../images/uganda10.jpeg';
import uganda11 from '../images/uganda11.jpeg';
import uganda12 from '../images/uganda12.jpeg';
import uganda13 from '../images/uganda13.jpeg';
import uganda14 from '../images/uganda14.jpeg';
import uganda15 from '../images/uganda15.jpeg';
import uganda16 from '../images/uganda16.jpeg';
import uganda17 from '../images/uganda17.jpeg';
import uganda18 from '../images/uganda18.jpeg';
import uganda19 from '../images/uganda19.jpeg';
import uganda20 from '../images/uganda20.jpeg';
import uganda21 from '../images/uganda21.jpeg';
import uganda22 from '../images/uganda22.jpeg';
import uganda23 from '../images/uganda23.jpeg';
import uganda24 from '../images/uganda24.jpeg';
import uganda25 from '../images/uganda25.jpeg';
import uganda26 from '../images/uganda26.jpeg';
import uganda27 from '../images/uganda27.jpeg';
import uganda28 from '../images/uganda28.jpeg';
import uganda29 from '../images/uganda29.jpeg';
import uganda30 from '../images/uganda30.jpeg';
import uganda31 from '../images/uganda31.jpeg';
import uganda32 from '../images/uganda32.jpeg';
import uganda33 from '../images/uganda33.jpeg';
import uganda34 from '../images/uganda34.jpeg';
import uganda35 from '../images/uganda35.jpeg';
import uganda36 from '../images/uganda36.jpeg';
import uganda37 from '../images/uganda37.jpeg';
import uganda38 from '../images/uganda38.jpeg';
import uganda39 from '../images/uganda39.jpeg';
import uganda40 from '../images/uganda40.jpeg';
import uganda41 from '../images/uganda41.jpeg';
import uganda42 from '../images/uganda42.jpeg';
import uganda43 from '../images/uganda43.jpeg';
import uganda44 from '../images/uganda44.jpeg';
import uganda45 from '../images/uganda45.jpeg';
import uganda46 from '../images/uganda46.jpeg';
import uganda47 from '../images/uganda47.jpeg';
import uganda48 from '../images/uganda48.jpeg';
import uganda49 from '../images/uganda49.jpeg';
import uganda50 from '../images/uganda50.jpeg';
import uganda51 from '../images/uganda51.jpeg';
import uganda52 from '../images/uganda52.jpeg';
import uganda53 from '../images/uganda53.jpeg';
import uganda54 from '../images/uganda54.jpeg';
import uganda55 from '../images/uganda55.jpeg';
import uganda56 from '../images/uganda56.jpeg';
import uganda57 from '../images/uganda57.jpeg';
import uganda58 from '../images/uganda58.jpeg';
import uganda59 from '../images/uganda59.jpeg';
import uganda60 from '../images/uganda60.jpeg';
import uganda61 from '../images/uganda61.jpeg';
import uganda62 from '../images/uganda62.jpeg';
import uganda63 from '../images/uganda63.jpeg';
import uganda64 from '../images/uganda64.jpeg';
import uganda65 from '../images/uganda65.jpeg';
import uganda66 from '../images/uganda66.jpeg';
import uganda67 from '../images/uganda67.jpeg';
import uganda68 from '../images/uganda68.jpeg';
import uganda69 from '../images/uganda69.jpeg';
import uganda70 from '../images/uganda70.jpeg';
import uganda71 from '../images/uganda71.jpeg';
import uganda72 from '../images/uganda72.jpeg';
import uganda73 from '../images/uganda73.jpeg';
import uganda74 from '../images/uganda74.jpeg';
import uganda75 from '../images/uganda75.jpeg';
import uganda76 from '../images/uganda76.jpeg';
import uganda77 from '../images/uganda77.jpeg';
import uganda78 from '../images/uganda78.jpeg';
import uganda79 from '../images/uganda79.jpeg';
import uganda80 from '../images/uganda80.jpeg';
import uganda81 from '../images/uganda81.jpeg';
import uganda82 from '../images/uganda82.jpeg';
import uganda83 from '../images/uganda83.jpeg';
import uganda84 from '../images/uganda84.jpeg';
import uganda85 from '../images/uganda85.jpeg';
import uganda86 from '../images/uganda86.jpeg';

function Uganda() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    uganda1, uganda2, uganda3, uganda4, uganda5, uganda6, uganda7, uganda8,
    uganda9, uganda10, uganda11, uganda12, uganda13, uganda14, uganda15, uganda16,
    uganda17, uganda18, uganda19, uganda20, uganda21, uganda22, uganda23, uganda24,
    uganda25, uganda26, uganda27, uganda28, uganda29, uganda30, uganda31, uganda32,
    uganda33, uganda34, uganda35, uganda36, uganda37, uganda38, uganda39, uganda40,
    uganda41, uganda42, uganda43, uganda44, uganda45, uganda46, uganda47, uganda48,
    uganda49, uganda50, uganda51, uganda52, uganda53, uganda54, uganda55, uganda56,
    uganda57, uganda58, uganda59, uganda60, uganda61, uganda62, uganda63, uganda64,
    uganda65, uganda66, uganda67, uganda68, uganda69, uganda70, uganda71, uganda72,
    uganda73, uganda74, uganda75, uganda76, uganda77, uganda78, uganda79, uganda80,
    uganda81, uganda82, uganda83, uganda84, uganda85, uganda86
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇺🇬 Uganda 2024 🇺🇬</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Uganda ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Uganda;